<!-- 商户对账列表 -->
<template>
    <div class="main-container">
        <div class="filter-container">
            <!-- <el-input class="filter-item" v-model="filters.brand_ids" placeholder="品牌ID，多个以英文逗号分隔" style="width:230px" clearable></el-input> -->
            <el-select-v2
                class="filter-item" 
                filterable 
                v-model="filters.brand_id"
                :options="brandList"
                :props="brandProps" 
                placeholder="品牌" 
                style="width:300px" 
                clearable
            />
            <el-select class="filter-item" v-model="filters.time_type" placeholder="时间类型" style="width:160px" clearable>
                <el-option label="下单时间" :value="1"></el-option>
                <el-option label="配送时间" :value="2"></el-option>
            </el-select>
            <el-date-picker class="filter-item" v-model="filters.start_date" placeholder="开始日期" value-format="YYYY-MM-DD" style="width:170px"></el-date-picker>
            <span class="filter-item filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" placeholder="结束日期" value-format="YYYY-MM-DD" style="width:170px"></el-date-picker>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <!-- <el-button class="filter-btn" type="primary" @click="onExport()">导出</el-button> -->
            <el-button v-if="user_id != 6079" class="filter-item" type="primary" @click="toNew">商家对账</el-button>
            <el-divider></el-divider>
            <div class="summary-box">
                <div class="summary-item" v-if="UserType[user_type]==='蛋叔员工'">
                    <p class="label">结算总金额 (元)</p>
                    <p class="txt">{{tableData[0]?.jiesuan_total || 0}}</p>
                </div>
                <div class="summary-item">
                    <p class="label">总订单数量</p>
                    <p class="txt">{{summary.totalOrderNum}}</p>
                </div>
                <div class="summary-item">
                    <p class="label">总商品数量</p>
                    <p class="txt">{{summary.totalProductNum}}</p>
                </div>
            </div>
            <el-divider></el-divider>
        </div>
        <el-table :data="tableData" stripe border style="width:100%">
            <el-table-column prop="brand_id" label="品牌ID"></el-table-column>
            <el-table-column prop="brand_name" label="品牌"></el-table-column>
            <el-table-column prop="shop_discount" label="商品折扣"></el-table-column>
            <el-table-column prop="invoice_type" label="专票普票"></el-table-column>
            <el-table-column prop="tax_Point" label="税点" width="60"></el-table-column>
            <el-table-column prop="brand_type" label="品牌类型"></el-table-column>
            <el-table-column prop="sum_total_amount" label="订单总金额" v-if="UserType[user_type]==='蛋叔员工'"></el-table-column>
            <el-table-column prop="jiesuan_total" label="结算总金额"></el-table-column>
            <el-table-column prop="order_num" label="订单数量"></el-table-column>
            <el-table-column prop="product_num" label="商品数量"></el-table-column>
            <el-table-column label="操作" width="210">
                <template #default="scope">
                    <div class="action-list">
                        <router-link v-if="user_id != 6079" :to="`/merchant-admin/reconcile-order-list?brand_id=${scope.row.brand_id}&start_date=${filters.start_date}&end_date=${filters.end_date}&time_type=${filters.time_type}&user_id=${user_id}`">
                            <el-tag size="small">订单列表</el-tag>
                        </router-link>
                        <template v-if="UserType[user_type]==='蛋叔员工' && user_id != 6079">
                            <el-tag v-if="scope.row.remittance_status==0" size="small" @click="onCheckOrder(scope.row)">对账</el-tag>
                            <el-tag v-else size="small" type="info">已对账</el-tag>
                        </template>                        
                        <el-tag size="small" @click="onExport(scope.row.brand_id)">导出</el-tag>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="total" @pageChange="onPageChange" @sizeChange="onSizeChange" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'
import { dateFormat } from '../../utils/index'
import { UserType } from '@/enums/user'
import dayjs from 'dayjs'
export default defineComponent({
name: 'ShopReconcileList',
components: {Pagination},
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()
    
    const user_id = store.state.user.userInfo.id
    
    const state = reactive({
        user_type: store.state.user.userInfo.user_type,   // 用户类型        
        filters: {
            time_type:  2,  // 搜索日期类型：1-下单时间，2-配送时间
            start_date: '', // 开始日期
            end_date:   '', // 结束日期
            brand_ids:  '', // 搜索品牌多个ID
            brand_id:   '', // 搜索品牌ID
            limit:      10, // 每页条数
            page:       1,  // 当前页码
        },
        tableData:      [], // 表格数据
        summary:        [], // 总览数据
        total:          0,  // 总条数
        brandList:      [], // 当前用户关联品牌（非商户类获取全部）
        brandProps: {
            value: 'id',
            label: 'name'
        },
        // 获取列表数据
        getList(){
            if (!state.filters.brand_id) { return proxy.$message({ type: 'error', message: '请选择品牌' }) }
            proxy.$http.get('/admin/merchant/get_merchant_reconciliation', state.filters).then(res => {                
                if(res.code == 200){
                    state.tableData = res.data.data;
                    state.summary = res.data.totalData;
                    state.total = res.data.data.length;
                }else{
                    proxy.$message({ type: 'error', message: res.msg })
                    state.tableData = [];
                }
            })
        },
        // 配置默认搜索日期
        setDefaultDateRange(){
            var today = new Date()
            // 得到上一个月的第一天  
            var lastMonthFirstDay = new Date(today.getFullYear() , today.getMonth()-1 , 1)
            // 得到本月第一天  
            var nowMonthFirstDay = new Date(today.getFullYear() , today.getMonth(), 1)
            // 得到上一个月的最后一天的毫秒值  
            // var lastMonthLastDay = new Date(nowMonthFirstDay.getTime() - 1000*60*60*24)
            
            state.filters.start_date = dateFormat(lastMonthFirstDay)
            state.filters.end_date = dateFormat(nowMonthFirstDay)
        },
        // 搜索
        search(){
            state.filters.page = 1
            state.getList()
        },
        // 对账申请
        onCheckOrder(row) {
            proxy.$confirm('确定已完成对账', '提示', {
                type: 'warning'
            }).then(() => {
                const {order_month, brand_id, order_num, sum_total_amount:order_money, sum_final_amount:order_finnal, jiesuan_total} = row
                proxy.$http.post('/admin/merchant/doReconciliation', {order_month, brand_id, order_num, order_money, order_finnal, jiesuan_total}).then(res => {
                    const {code, msg} = res
                    if (code == 0) {
                        proxy.$message({
                            type: 'success',
                            message: '对账完成'
                        })
                        setTimeout(() => {
                            proxy.getList()
                        }, 1000)
                    } else {
                        proxy.$message({
                            type: 'error',
                            message: msg
                        })
                    }
                })
            }).catch(() => {
                console.log('取消对账操作')
            })
        },
        // 导出
        onExport(brand_id) {
            const { start_date, end_date, time_type } = state.filters
            //获取当前日期的年月日
            var now = new Date();
            var day = now.getDate();
            if(day <= 3 ){
                const now = dayjs();
                //获取上个月的第一天
                const lastMonth = now.subtract(1, 'month'); // 设置日期为月份的第一天 
                const firstDayOfLastMonth = lastMonth.startOf('month').format('YYYY-MM-DD');
                //获取这个月的第一天
                const nowMonth = now.startOf('month');
                const firstDayOfNowMonth = nowMonth.startOf('month').format('YYYY-MM-DD');
                if(start_date == firstDayOfLastMonth && end_date == firstDayOfNowMonth ){
                    const formattedMessage =  `<div style="text-align: center;line-height: 20px;">月度对账数据于每月3号之后即可导出</div>`
                    return proxy.$message({ type: 'error',duration: 5000,dangerouslyUseHTMLString: true, message: formattedMessage })  
                }           
            }
            // let str = brand_id ? 'shopOrderListOutput' : 'shopReconcileListOutPut'
            window.open(`${Keys.baseUrl}/admin/merchant/get_merchant_reconciliation?brand_id=${brand_id}&start_date=${start_date}&end_date=${end_date}&time_type=${time_type}&user_id=${user_id}&if_export=1`);
                
            // 菜单提醒清除
            store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'shopduizhang', store.state.user.menuWarning.shopduizhang)
        },
        // 跳转到新对账列表
        toNew:() =>{
            router.push(`/merchant-admin/shop_reconciliation-list`)
        },
        // 获取当前用户关联品牌列表
        getBrandList:()=>{
            proxy.$http.post('/admin/shop_product/getBrandList?id_show=1').then((res) => {
                state.brandList = res.data
                if (state.brandList.length === 1) {
                    state.filters.brand_id = state.brandList[0].id
                    state.getList()
                }
            })
        },
        // 分页
        onPageChange(val) {
            state.filters.page = val
            state.getList();
        },
        onSizeChange  (val) {
            state.filters.limit = val
            state.getList();
        },
    })
    state.setDefaultDateRange()
    state.getBrandList()
    return { ...toRefs(state), store, Keys, user_id, UserType }
}
})
</script>

<style lang="stylus" scoped>
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
.summary-box
    display flex
    justify-content space-around
.summary-item
    text-align center
    .label
        font-size 18px
    .txt
        font-size 16px
        font-weight bold
        margin-top 20px
        color #666666
</style>